export const isProductionRelease = () => {
  return false //process.env.REACT_APP_BRANCH !== 'develop' && process.env.REACT_APP_BRANCH !== 'local-dev';
};
